import { css } from "styled-components";

export const customScrollbar = css`
  &::-webkit-scrollbar {
    width: 8px;
    height: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #F0E4D3;
    border-radius: 16px;
    transition: background-color 120ms ease;
  }
  &::-webkit-scrollbar-thumb:hover {
    background-color: #D4C4A8;
  }
  &::-webkit-scrollbar-thumb:active {
    background-color: #A8916A;
  }
`;
